import React from 'react';
import { ThemeProvider } from 'styled-components';
import { DefaultTheme } from '../../Themes';
const Label = ({ className, labelFor, onClick, text, theme = DefaultTheme, }) => (React.createElement(ThemeProvider, { theme: theme },
    React.createElement("label", { className: className, onClick: onClick, htmlFor: labelFor }, text)));
export default Label;
